import React, { Component } from "react";
import RouteManager from "../../managers/RouteManager";
import UserManager from "../../managers/UserManager";

export default class Support extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		RouteManager.setPresenter(this);
		if (!UserManager.isUserOwner() && !UserManager.isUserAdmin()) {
			RouteManager.navigateToHome();
			return;
		}
	}
	render() {
		return <div className="fs-xxl fw-m">Support page</div>;
	}
}
